import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { InlineNotification } from '../../compass-ui'
import { useAnalytics } from '../../context/Analytics'
import {
  getErrorKeys,
  getFieldValidationErrors,
} from '../../hooks/useFormValidation/useFormValidation'

type FormValidationErrorProps = {
  hasCreditProtection?: boolean
}

const FormValidationError: FC<FormValidationErrorProps> = ({ hasCreditProtection = false }) => {
  const { track, events } = useAnalytics()
  const {
    setFocus,
    formState: { errors },
    getValues,
  } = useFormContext()

  return (
    <>
      {Object.keys(errors).length > 0 ? (
        <InlineNotification variation="error">
          <span>
            Please{' '}
            <button
              onClick={() => {
                const formValidationErrors = getFieldValidationErrors(
                  getErrorKeys(getValues(), hasCreditProtection),
                  errors
                )
                track?.(events.INTERACTION.SetFormErrorFocusClick)
                track?.(events.ERROR.GenericFormValidationError, {
                  formValidationErrors,
                })
                setFocus(formValidationErrors[0])
              }}
              className="underline text-blue-600"
              id="correct-errors-button"
              data-testid="correct-errors-button"
            >
              correct the errors
            </button>{' '}
            and try submitting again.
          </span>
        </InlineNotification>
      ) : null}
    </>
  )
}

export default FormValidationError
